// @ts-ignore
/* eslint-disable */
import request from './request';

/** uploadFile */
export async function uploadFile(values) {
    return request.post('/file/uploadFile', values);
}
